import { useEffect } from "react";

import { Tabs } from "antd";

import { useAppDispatch, useAppSelector } from "store";
import { getInvitations } from "store/invitations/invitations.thunks";
import { updateInvitationsFilter } from "store/invitations/invitations.actions";
import { getInvitationsSelector } from "store/invitations/invitations.selector";

const tabs = [
  {
    key: "inbox",
    label: "Inbox",
  },
  {
    key: "outbox",
    label: "Outbox",
  },
];

const ContractInvitationsHeader = () => {
  const dispatch = useAppDispatch();
  const { filter } = useAppSelector(getInvitationsSelector);

  useEffect(() => {
    dispatch(getInvitations());
  }, [ filter.type ]);

  return (
    <Tabs
      items={ tabs }
      activeKey={ filter.type }
      onChange={ value => dispatch(updateInvitationsFilter({ type: value })) }
    />
  );
};

export default ContractInvitationsHeader;
